import "./logout.css";
import React, {useState} from "react";
import {useTranslation} from "react-i18next";
import {useNavigate} from "react-router-dom";
import { connect } from "react-redux";
import Alert from "react-bootstrap/Alert";
import apiClient from "../../utils/axios";
import {clearData} from "../../utils/clearData"
import {setAppData} from "../../redux/register_store";
import {setLoginInfo} from "../../redux/login_store";
import {setPersonalData} from "../../redux/personal_store";
import {setFinancialInfo} from "../../redux/financial_store";
import {setAffiliationField} from "../../redux/affiliation_store";
import {setExpInfoData} from "../../redux/experience_store";
import {setConditionInfo} from "../../redux/conditions_store";
import {setCustodialData} from "../../redux/custodial_acc_store";
import {setOwnerData} from "../../redux/owner_info_store";
import {setAuthInfo} from "../../redux/auth_singer_store";
import {setVerifyInfo} from "../../redux/verify_password_store";

function Logout(props) {
    const {
        setAppData,
        setLoginInfo,
        setPersonalData,
        setFinancialInfo,
        setAffiliationField,
        setExpInfoData,
        setConditionInfo,
        setCustodialData,
        setOwnerData,
        setAuthInfo,
        setVerifyInfo,
    } = props;

    const {t} = useTranslation();
    const [show, setShow] = useState(false);
    const navigate = useNavigate();

    const handleLogout = async () => {
        try {
            await apiClient.post(`${process.env.REACT_APP_API_URL}/api/logout`, {}, {
                withCredentials: true,
            });

            localStorage.clear();
            sessionStorage.clear();

            clearData({
                setAppData,
                setLoginInfo,
                setPersonalData,
                setFinancialInfo,
                setAffiliationField,
                setExpInfoData,
                setConditionInfo,
                setCustodialData,
                setOwnerData,
                setAuthInfo,
                setVerifyInfo,
            });

            navigate('/login');
        } catch (error) {
            localStorage.clear();
            sessionStorage.clear();

            clearData({
                setAppData,
                setLoginInfo,
                setPersonalData,
                setFinancialInfo,
                setAffiliationField,
                setExpInfoData,
                setConditionInfo,
                setCustodialData,
                setOwnerData,
                setAuthInfo,
                setVerifyInfo,
            });

            navigate('/login');
        }
    };

    return (
        <div className="pb-2">
            <div className="flex justify-content-end pb-3">
                <button
                    className="logout_btn w-auto h-3rem flex justify-content-center align-items-center gap-2 border-0 px-2 px-4"
                    onClick={() => setShow(!show)}>
                    <span className="logout_btn_text text-white text-center font-normal text-xl">
                        {t('logout')}
                    </span>
                </button>
            </div>

            {show && (
                <Alert variant="dark">
                    {t('logout_modal.logout_text')}
                    <div className="flex justify-content-center gap-3 pt-2">
                        <button
                            onClick={handleLogout}
                            className="logout_ok_btn_link w-auto border-0 border-round-sm text-white px-1 px-5">
                            {t('logout_modal.ok')}
                        </button>
                        <button
                            className="logout_cancel_btn w-auto border-0 text-white px-1 px-4 border-round-sm"
                            onClick={() => setShow(!show)}>
                            {t('logout_modal.cancel')}
                        </button>
                    </div>
                </Alert>
            )}
        </div>
    );
}

const mapDispatchToProps = {
    setAppData,
    setLoginInfo,
    setPersonalData,
    setFinancialInfo,
    setAffiliationField,
    setExpInfoData,
    setConditionInfo,
    setCustodialData,
    setOwnerData,
    setAuthInfo,
    setVerifyInfo,
};

export default connect(null, mapDispatchToProps)(Logout);
